// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    padding-top: 80px; /* Account for navbar (60px) plus some spacing */
    background-color: #f4f4f4;
    min-height: 100vh;
}

.home-header {
    text-align: center;
    margin-bottom: 30px;
    margin-top: 20px;
}

.home-header h1 {
    font-size: 3rem;
    color: #44ACC9;
    margin: 0;
}

.home-header p {
    font-size: 1.2rem;
    color: #555;
}

.home-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 80%;
    max-width: 1200px;
    line-height: 1.6;
    margin: 20px auto; /* Center horizontally and add vertical spacing */
}

.home-content h2 {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
}

.intro-text {
    text-align: justify;
    color: #333;
    font-size: 1rem;
    margin-bottom: 40px;
}

.intro-text p {
    margin: 10px 0;
}

.intro-text ul {
    margin: 10px 0 10px 20px;
    padding-left: 20px;
    list-style-type: disc;
}

.intro-text ul ul {
    list-style-type: circle;
    margin-left: 20px;
}

.intro-text strong {
    color: #000;
}

.home-content img {
    display: block;
    margin: 20px auto 0; 
    max-width: 100%;
    height: auto;
    border: 2px solid #ddd;
    border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Home.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,iBAAiB,EAAE,gDAAgD;IACnE,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB,EAAE,iDAAiD;AACxE;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB","sourcesContent":[".home {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    padding-top: 80px; /* Account for navbar (60px) plus some spacing */\n    background-color: #f4f4f4;\n    min-height: 100vh;\n}\n\n.home-header {\n    text-align: center;\n    margin-bottom: 30px;\n    margin-top: 20px;\n}\n\n.home-header h1 {\n    font-size: 3rem;\n    color: #44ACC9;\n    margin: 0;\n}\n\n.home-header p {\n    font-size: 1.2rem;\n    color: #555;\n}\n\n.home-content {\n    background: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n    width: 80%;\n    max-width: 1200px;\n    line-height: 1.6;\n    margin: 20px auto; /* Center horizontally and add vertical spacing */\n}\n\n.home-content h2 {\n    text-align: center;\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.intro-text {\n    text-align: justify;\n    color: #333;\n    font-size: 1rem;\n    margin-bottom: 40px;\n}\n\n.intro-text p {\n    margin: 10px 0;\n}\n\n.intro-text ul {\n    margin: 10px 0 10px 20px;\n    padding-left: 20px;\n    list-style-type: disc;\n}\n\n.intro-text ul ul {\n    list-style-type: circle;\n    margin-left: 20px;\n}\n\n.intro-text strong {\n    color: #000;\n}\n\n.home-content img {\n    display: block;\n    margin: 20px auto 0; \n    max-width: 100%;\n    height: auto;\n    border: 2px solid #ddd;\n    border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
